export const isSafari = () => {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const isIOSDevice = () => {
	return /iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
};

/**
 * @deprecated Use isFirefoxBrowser() function instead for consistency with other browser detection functions.
 * This constant is evaluated at module load time, which can cause issues in SSR or test environments.
 */
export const isFirefox = typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);

/**
 * Detect if the browser is Google Chrome (not Edge, not Opera).
 * Chrome's userAgent contains "Chrome" but Edge also contains "Chrome" + "Edg".
 */
export const isChrome = (): boolean => {
	if (typeof navigator === 'undefined') return false;
	const ua = navigator.userAgent;
	return /chrome/i.test(ua) && !/edg/i.test(ua) && !/opr/i.test(ua);
};

/**
 * Detect if the browser is Microsoft Edge.
 * Edge's userAgent contains both "Chrome" and "Edg".
 */
export const isEdge = (): boolean => {
	if (typeof navigator === 'undefined') return false;
	return /edg/i.test(navigator.userAgent);
};

/**
 * Detect if the browser is Firefox (function form for consistency).
 */
export const isFirefoxBrowser = (): boolean => {
	if (typeof navigator === 'undefined') return false;
	return /firefox/i.test(navigator.userAgent);
};

export type BrowserName = 'chrome' | 'edge' | 'firefox' | 'safari' | 'other';

/**
 * Get the name of the current browser for display purposes.
 * Used for showing browser-specific instructions (e.g., mic permission recovery).
 */
export const getBrowserName = (): BrowserName => {
	if (isEdge()) return 'edge';
	if (isChrome()) return 'chrome';
	if (isFirefoxBrowser()) return 'firefox';
	if (isSafari()) return 'safari';
	return 'other';
};
